import React from 'react';
import { Navigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

const isTokenValid = () => {
  const token = localStorage.getItem('jwt');
  if (!token) return false;

  try {
    const decoded = jwtDecode(token);
    const now = Math.floor(Date.now() / 1000); // current time in seconds
    if (decoded.exp && decoded.exp < now) {
      // Token expired
      localStorage.removeItem('jwt');
      localStorage.removeItem('user');
      return false;
    }
    return true;
  } catch (err) {
    console.error("Invalid JWT:", err);
    return false;
  }
};

const PrivateRoute = ({ children }) => {
  const isAuthenticated = isTokenValid();
  return isAuthenticated ? children : <Navigate to="/login" />;
};

export default PrivateRoute;
